var $e73bf42412feb220$exports = {};
// Main App - Orchestrates game logic and state management
if (new URLSearchParams(window.location.search).get("__debug__") === "1") window.__debug__ = true;
if (window.__debug__) console.debug("App loading...");
const $e73bf42412feb220$var$App = {
    state: {
        puzzle: null,
        solution: null,
        currentBoard: null,
        givenCells: null,
        difficulty: null,
        selectedCell: {
            row: null,
            col: null
        },
        startTime: null,
        elapsedTime: 0,
        timerInterval: null,
        isPaused: false,
        hasTrackedAttempt: false,
        moveHistory: []
    },
    preferences: {
        timerEnabled: true,
        hintsEnabled: true,
        numberHighlightEnabled: true
    },
    // Initialize the app
    init () {
        if (window.__debug__) console.debug("App.init() called");
        window.UIController.init();
        this.loadPreferences();
        this.attachEventListeners();
        this.checkForSavedGame();
        if (window.__debug__) console.debug("App initialized successfully");
    },
    // Load preferences from storage
    loadPreferences () {
        this.preferences = window.Storage.loadPreferences();
        window.UIController.updatePreferencesUI(this.preferences);
    },
    // Check for saved game
    checkForSavedGame () {
        const savedGame = window.Storage.loadGame();
        window.UIController.showContinueButton(savedGame);
    },
    // Attach event listeners
    attachEventListeners () {
        // Undo button
        window.UIController.elements.undoBtn.addEventListener("click", ()=>{
            this.undoMove();
        });
        // Initial state for Undo button
        this.updateUndoButton();
        if (window.__debug__) console.debug("Attaching event listeners...");
        // Difficulty buttons
        window.UIController.elements.difficultyBtns.forEach((btn)=>{
            btn.addEventListener("click", ()=>{
                if (window.__debug__) console.debug("Difficulty button clicked:", btn.dataset.difficulty);
                const difficulty = btn.dataset.difficulty;
                this.startNewGame(difficulty);
            });
        });
        // Continue button
        window.UIController.elements.continueBtn.addEventListener("click", ()=>{
            this.continueGame();
        });
        // Settings button
        window.UIController.elements.settingsBtn.addEventListener("click", ()=>{
            window.UIController.showModal("settings");
        });
        // Stats button
        window.UIController.elements.statsBtn.addEventListener("click", ()=>{
            const stats = window.Storage.loadStats();
            window.UIController.renderStats(stats);
            window.UIController.showModal("stats");
        });
        // Back button
        window.UIController.elements.backBtn.addEventListener("click", ()=>{
            this.pauseGame();
            window.UIController.showModal("pause");
        });
        // Hint button
        window.UIController.elements.hintBtn.addEventListener("click", ()=>{
            this.giveHint();
        });
        // Pause button
        window.UIController.elements.pauseBtn.addEventListener("click", ()=>{
            this.pauseGame();
            window.UIController.showModal("pause");
        });
        // Resume button
        window.UIController.elements.resumeBtn.addEventListener("click", ()=>{
            window.UIController.hideModal("pause");
            this.resumeGame();
        });
        // Quit button
        window.UIController.elements.quitBtn.addEventListener("click", ()=>{
            this.saveGame();
            window.UIController.hideModal("pause");
            window.UIController.showScreen("home");
            this.stopTimer();
        });
        // Cell selection
        window.UIController.elements.sudokuGrid.addEventListener("click", (e)=>{
            const cell = e.target.closest(".cell");
            if (!cell) return;
            const row = Number.parseInt(cell.dataset.row);
            const col = Number.parseInt(cell.dataset.col);
            // Prevent selecting given cells when number highlighting is disabled
            const isGiven = this.state.givenCells && this.state.givenCells[row] && this.state.givenCells[row][col];
            if (isGiven && !this.preferences.numberHighlightEnabled) return; // ignore click on original puzzle number
            this.selectCell(row, col);
        });
        // Keypad buttons
        window.UIController.elements.keypadBtns.forEach((btn)=>{
            btn.addEventListener("click", ()=>{
                // Only handle number input for buttons with a valid data-number
                if (btn.dataset.number !== undefined && btn.dataset.number !== null) {
                    const number = Number.parseInt(btn.dataset.number, 10);
                    if (!isNaN(number)) this.handleNumberInput(number);
                }
            });
        });
        // Victory modal buttons
        window.UIController.elements.newGameBtn.addEventListener("click", ()=>{
            window.UIController.hideModal("victory");
            this.startNewGame(this.state.difficulty);
        });
        window.UIController.elements.menuBtn.addEventListener("click", ()=>{
            window.UIController.hideModal("victory");
            window.UIController.showScreen("home");
            window.Storage.clearGame();
            this.checkForSavedGame();
        });
        // Settings modal
        window.UIController.elements.timerToggle.addEventListener("change", (e)=>{
            this.preferences.timerEnabled = e.target.checked;
            window.Storage.savePreferences(this.preferences);
            window.UIController.toggleTimerDisplay(this.preferences.timerEnabled);
        });
        window.UIController.elements.hintsToggle.addEventListener("change", (e)=>{
            this.preferences.hintsEnabled = e.target.checked;
            window.Storage.savePreferences(this.preferences);
            window.UIController.showHintButton(this.preferences.hintsEnabled);
        });
        window.UIController.elements.highlightToggle.addEventListener("change", (e)=>{
            this.preferences.numberHighlightEnabled = e.target.checked;
            window.Storage.savePreferences(this.preferences);
        });
        window.UIController.elements.clearDataBtn.addEventListener("click", ()=>{
            if (confirm("Are you sure you want to clear all data? This cannot be undone.")) {
                window.Storage.clearAll();
                window.UIController.hideModal("settings");
                window.UIController.showScreen("home");
                this.checkForSavedGame();
            }
        });
        window.UIController.elements.closeSettingsBtn.addEventListener("click", ()=>{
            window.UIController.hideModal("settings");
        });
        // Stats modal
        window.UIController.elements.closeStatsBtn.addEventListener("click", ()=>{
            window.UIController.hideModal("stats");
        });
        // Save game on page unload
        window.addEventListener("beforeunload", ()=>{
            if (this.state.puzzle) this.saveGame();
        });
        // Keyboard support for desktop
        // Numbers 1-9 fill selected cell, 0/Delete/Backspace clears
        // Arrow keys move selection, H gives hint (if enabled), U undo, N new game (same difficulty), P/Escape pause
        document.addEventListener("keydown", (e)=>{
            // Only active during a game
            const gameActive = window.UIController.elements.gameScreen.classList.contains("active");
            if (!gameActive) return;
            // If any modal/overlay is open, ignore all except Escape to close pause (handled below)
            const modalOpen = document.querySelector(".overlay.active, .modal.active");
            if (modalOpen) {
                if (e.key === "Escape") {
                    // If pause overlay open, resume
                    const pauseOverlay = window.UIController.elements.pauseOverlay;
                    if (pauseOverlay && pauseOverlay.classList.contains("active")) {
                        window.UIController.hideModal("pause");
                        this.resumeGame();
                    }
                }
                return;
            }
            const { row: row, col: col } = this.state.selectedCell;
            const isGiven = (r, c)=>{
                return this.state.givenCells && this.state.givenCells[r] && this.state.givenCells[r][c];
            };
            const isEmpty = (r, c)=>this.state.currentBoard?.[r]?.[c] === 0;
            const moveSelection = (dr, dc, opts = {
                jumpEmpty: false
            })=>{
                let r = row;
                let c = col;
                if (r === null || c === null) {
                    r = 0;
                    c = 0;
                } else {
                    r = Math.min(8, Math.max(0, r + dr));
                    c = Math.min(8, Math.max(0, c + dc));
                }
                // If Shift pressed and jumpEmpty requested, scan ahead for next empty cell
                if (opts.jumpEmpty) {
                    let rr = r;
                    let cc = c;
                    for(let step = 0; step < 8; step++){
                        if (isEmpty(rr, cc)) {
                            r = rr;
                            c = cc;
                            break;
                        }
                        rr = Math.min(8, Math.max(0, rr + dr));
                        cc = Math.min(8, Math.max(0, cc + dc));
                    }
                }
                // When number highlighting is disabled, avoid selecting given cells
                if (!this.preferences.numberHighlightEnabled && isGiven(r, c)) {
                    let rr = r;
                    let cc = c;
                    // advance until a non-given is found or boundary reached
                    for(let step = 0; step < 8; step++){
                        rr = Math.min(8, Math.max(0, rr + dr));
                        cc = Math.min(8, Math.max(0, cc + dc));
                        if (!isGiven(rr, cc)) {
                            r = rr;
                            c = cc;
                            break;
                        }
                    }
                }
                this.selectCell(r, c);
            };
            switch(e.key){
                case "ArrowUp":
                    moveSelection(-1, 0, {
                        jumpEmpty: e.shiftKey
                    });
                    e.preventDefault();
                    break;
                case "ArrowDown":
                    moveSelection(1, 0, {
                        jumpEmpty: e.shiftKey
                    });
                    e.preventDefault();
                    break;
                case "ArrowLeft":
                    moveSelection(0, -1, {
                        jumpEmpty: e.shiftKey
                    });
                    e.preventDefault();
                    break;
                case "ArrowRight":
                    moveSelection(0, 1, {
                        jumpEmpty: e.shiftKey
                    });
                    e.preventDefault();
                    break;
                case "Home":
                    {
                        // Go to start of row
                        let r = row ?? 0;
                        let c = 0;
                        // Respect highlight preference: skip given if disabled
                        if (!this.preferences.numberHighlightEnabled && isGiven(r, c)) {
                            for(let cc = 0; cc < 9; cc++)if (!isGiven(r, cc)) {
                                c = cc;
                                break;
                            }
                        }
                        this.selectCell(r, c);
                        e.preventDefault();
                        break;
                    }
                case "End":
                    {
                        // Go to end of row
                        let r = row ?? 0;
                        let c = 8;
                        if (!this.preferences.numberHighlightEnabled && isGiven(r, c)) {
                            for(let cc = 8; cc >= 0; cc--)if (!isGiven(r, cc)) {
                                c = cc;
                                break;
                            }
                        }
                        this.selectCell(r, c);
                        e.preventDefault();
                        break;
                    }
                case "PageUp":
                    {
                        // Go to start of column
                        let r = 0;
                        let c = col ?? 0;
                        if (!this.preferences.numberHighlightEnabled && isGiven(r, c)) {
                            for(let rr = 0; rr < 9; rr++)if (!isGiven(rr, c)) {
                                r = rr;
                                break;
                            }
                        }
                        this.selectCell(r, c);
                        e.preventDefault();
                        break;
                    }
                case "PageDown":
                    {
                        // Go to end of column
                        let r = 8;
                        let c = col ?? 0;
                        if (!this.preferences.numberHighlightEnabled && isGiven(r, c)) {
                            for(let rr = 8; rr >= 0; rr--)if (!isGiven(rr, c)) {
                                r = rr;
                                break;
                            }
                        }
                        this.selectCell(r, c);
                        e.preventDefault();
                        break;
                    }
                case "Backspace":
                case "Delete":
                case "0":
                    this.handleNumberInput(0);
                    e.preventDefault();
                    break;
                case "u":
                case "U":
                    this.undoMove();
                    e.preventDefault();
                    break;
                case "h":
                case "H":
                    if (this.preferences.hintsEnabled) {
                        this.giveHint();
                        e.preventDefault();
                    }
                    break;
                case "p":
                case "P":
                case "Escape":
                    this.pauseGame();
                    window.UIController.showModal("pause");
                    e.preventDefault();
                    break;
                case "n":
                case "N":
                    if (this.state.difficulty) {
                        this.startNewGame(this.state.difficulty);
                        e.preventDefault();
                    }
                    break;
                default:
                    if (/^[1-9]$/.test(e.key)) {
                        const num = Number.parseInt(e.key, 10);
                        this.handleNumberInput(num);
                        e.preventDefault();
                    }
                    break;
            }
        });
        if (window.__debug__) console.debug("Event listeners attached");
    },
    // Start a new game
    startNewGame (difficulty) {
        if (window.__debug__) console.debug("Starting new game with difficulty:", difficulty);
        // Generate puzzle
        const { puzzle: puzzle, solution: solution } = window.SudokuGenerator.generate(difficulty);
        // Initialize state
        this.state.puzzle = puzzle;
        this.state.solution = solution;
        this.state.currentBoard = window.SudokuSolver.copyBoard(puzzle);
        this.state.difficulty = difficulty;
        this.state.selectedCell = {
            row: null,
            col: null
        };
        this.state.elapsedTime = 0;
        this.state.isPaused = false;
        this.state.moveHistory = [];
        // Create given cells map
        this.state.givenCells = puzzle.map((row)=>row.map((cell)=>cell !== 0));
        // Reset attempt tracking flag
        this.state.hasTrackedAttempt = false;
        // Clear saved game
        window.Storage.clearGame();
        // Show game screen
        window.UIController.showScreen("game");
        window.UIController.updateDifficultyDisplay(difficulty);
        window.UIController.renderGrid(puzzle, this.state.currentBoard, this.state.givenCells);
        // Start timer if enabled
        window.UIController.toggleTimerDisplay(this.preferences.timerEnabled);
        if (this.preferences.timerEnabled) this.startTimer();
        // Update Undo button state
        this.updateUndoButton();
    },
    // Continue saved game
    continueGame () {
        const savedGame = window.Storage.loadGame();
        if (!savedGame) return;
        // Restore state
        this.state = {
            ...savedGame,
            timerInterval: null,
            isPaused: false,
            selectedCell: savedGame.selectedCell || {
                row: null,
                col: null
            },
            hasTrackedAttempt: savedGame.hasTrackedAttempt || false,
            moveHistory: savedGame.moveHistory || []
        };
        // Show game screen
        window.UIController.showScreen("game");
        window.UIController.updateDifficultyDisplay(this.state.difficulty);
        window.UIController.renderGrid(this.state.puzzle, this.state.currentBoard, this.state.givenCells);
        // Resume timer if enabled
        window.UIController.toggleTimerDisplay(this.preferences.timerEnabled);
        if (this.preferences.timerEnabled) this.startTimer();
        // Update Undo button state
        this.updateUndoButton();
    },
    // Save current game
    saveGame () {
        if (!this.state.puzzle) return;
        const gameState = {
            puzzle: this.state.puzzle,
            solution: this.state.solution,
            currentBoard: this.state.currentBoard,
            givenCells: this.state.givenCells,
            difficulty: this.state.difficulty,
            elapsedTime: this.state.elapsedTime,
            startTime: this.state.startTime,
            hasTrackedAttempt: this.state.hasTrackedAttempt,
            selectedCell: this.state.selectedCell,
            moveHistory: this.state.moveHistory
        };
        window.Storage.saveGame(gameState);
    },
    // Select a cell
    selectCell (row, col) {
        this.state.selectedCell = {
            row: row,
            col: col
        };
        window.UIController.highlightCell(row, col, this.state.currentBoard, this.preferences.numberHighlightEnabled);
    },
    // Handle number input
    handleNumberInput (number) {
        const { row: row, col: col } = this.state.selectedCell;
        if (row === null || col === null) return;
        if (this.state.givenCells[row][col]) return;
        // Track attempt on first move
        if (!this.state.hasTrackedAttempt && number !== 0) {
            window.Storage.incrementAttempts(this.state.difficulty);
            this.state.hasTrackedAttempt = true;
        }
        // Save move to history for undo (store previous value)
        const prevValue = this.state.currentBoard[row][col];
        if (prevValue !== number) {
            this.state.moveHistory.push({
                row: row,
                col: col,
                prevValue: prevValue
            });
            this.updateUndoButton();
        }
        // Update board
        this.state.currentBoard[row][col] = number;
        window.UIController.updateCell(row, col, number);
        // Check for conflicts
        const conflicts = window.SudokuSolver.getConflicts(this.state.currentBoard, row, col);
        if (conflicts.length > 0 && number !== 0) {
            conflicts.push({
                row: row,
                col: col
            });
            window.UIController.showConflicts(conflicts);
        } else window.UIController.showConflicts([]);
        // Check if puzzle is complete
        if (window.SudokuSolver.isComplete(this.state.currentBoard)) this.onPuzzleComplete();
        else // Save game after each move
        this.saveGame();
    },
    // Undo last move
    undoMove () {
        if (!this.state.moveHistory.length) return;
        const lastMove = this.state.moveHistory.pop();
        const { row: row, col: col, prevValue: prevValue } = lastMove;
        this.state.currentBoard[row][col] = prevValue;
        window.UIController.updateCell(row, col, prevValue);
        // Remove conflicts if any
        window.UIController.showConflicts([]);
        // Save game after undo
        this.saveGame();
        this.updateUndoButton();
    },
    // Enable/disable Undo button based on move history
    updateUndoButton () {
        const undoBtn = window.UIController.elements.undoBtn;
        if (!undoBtn) return;
        if (this.state.moveHistory.length > 0) {
            undoBtn.disabled = false;
            undoBtn.classList.remove("disabled");
        } else {
            undoBtn.disabled = true;
            undoBtn.classList.add("disabled");
        }
    },
    // Give a hint
    giveHint () {
        // Track attempt on first hint
        if (!this.state.hasTrackedAttempt) {
            window.Storage.incrementAttempts(this.state.difficulty);
            this.state.hasTrackedAttempt = true;
        }
        // Find all empty cells
        const emptyCells = [];
        for(let i = 0; i < 9; i++){
            for(let j = 0; j < 9; j++)if (this.state.currentBoard[i][j] === 0) emptyCells.push({
                row: i,
                col: j
            });
        }
        if (emptyCells.length === 0) return;
        // Pick a random empty cell
        const randomCell = emptyCells[Math.floor(Math.random() * emptyCells.length)];
        const { row: row, col: col } = randomCell;
        // Fill with correct number
        const correctNumber = this.state.solution[row][col];
        this.state.currentBoard[row][col] = correctNumber;
        window.UIController.updateCell(row, col, correctNumber);
        // Clear conflicts
        window.UIController.showConflicts([]);
        // Check if puzzle is complete
        if (window.SudokuSolver.isComplete(this.state.currentBoard)) this.onPuzzleComplete();
        else this.saveGame();
    },
    // Start timer
    startTimer () {
        this.state.startTime = Date.now() - this.state.elapsedTime * 1000;
        this.state.timerInterval = setInterval(()=>{
            if (!this.state.isPaused) {
                this.state.elapsedTime = Math.floor((Date.now() - this.state.startTime) / 1000);
                window.UIController.updateTimer(this.state.elapsedTime);
            }
        }, 1000);
    },
    // Stop timer
    stopTimer () {
        if (this.state.timerInterval) {
            clearInterval(this.state.timerInterval);
            this.state.timerInterval = null;
        }
    },
    // Pause game
    pauseGame () {
        this.state.isPaused = true;
        // Store the time when paused
        this.state.pauseTimestamp = Date.now();
        this.saveGame();
    },
    // Resume game
    resumeGame () {
        if (this.state.isPaused && this.state.pauseTimestamp) {
            // Adjust startTime to account for time spent paused
            const pausedDuration = Date.now() - this.state.pauseTimestamp;
            this.state.startTime += pausedDuration;
            delete this.state.pauseTimestamp;
        }
        this.state.isPaused = false;
    },
    // Handle puzzle completion
    onPuzzleComplete () {
        this.stopTimer();
        // Update statistics
        if (this.preferences.timerEnabled) window.Storage.updateStats(this.state.difficulty, this.state.elapsedTime);
        else window.Storage.updateStats(this.state.difficulty, 0);
        // Clear saved game
        window.Storage.clearGame();
        window.UIController.showContinueButton(false);
        // Show victory modal
        window.UIController.showVictory(this.state.elapsedTime, this.preferences.timerEnabled);
    }
};
// Initialize app when DOM is ready
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", ()=>{
    if (window.__debug__) console.debug("DOM loaded, initializing app");
    $e73bf42412feb220$var$App.init();
});
else {
    if (window.__debug__) console.debug("DOM already loaded, initializing app");
    $e73bf42412feb220$var$App.init();
}
if (window.__debug__) console.debug("App.js loaded");


//# sourceMappingURL=repo.40357518.js.map
